<app-initial-form-table
  [form]="form"
  controlName="skills"
  [rows]="skillsRows"
  [columns]="interestLevelsColumns"
  [selectionHandler]="handleSkillSelection"
  [isSelectedHandler]="isSelected"
  >
</app-initial-form-table>